import { StyledCategoriesList } from './CategoriesList.style';
import CategoryItem from './CategoryItem';
import _ from 'lodash';
import usePmFilters from './CategoryFilters/usePmFilters';
import { switchCategoriesOrder } from '../../useFormState/form.state.actions';
import { useAutoAnimate } from '@formkit/auto-animate/react';

const ORDER_DIRECTIONS = {
  UP: 'up',
  down: 'down'
};

const CategoriesList = ({ formState }) => {
  const [animationParent] = useAutoAnimate({ duration: 500 });
  const { dispatch, categories = [] } = formState;
  const pmFilters = usePmFilters();
  const orderedCategories = _.orderBy(categories, ['order'], ['asc']);

  const onOrderCategory = (e, category, dir) => {
    e.stopPropagation();
    const isMinus = dir === ORDER_DIRECTIONS.UP ? -1 : 1;
    const category2 = categories.find(
      cat => cat.order === category.order + 1 * isMinus
    );
    dispatch(switchCategoriesOrder(category.order, category2.order));
  };

  return (
    <StyledCategoriesList ref={animationParent}>
      {orderedCategories.map((category, idx) => (
        <li key={category.name}>
          <CategoryItem
            key={idx}
            category={category}
            pmFilters={pmFilters}
            dispatch={dispatch}
            isCollapsed={formState?.selectedCategory?.name !== category.name}
            {...(idx !== 0 && {
              onOrderUp: e => onOrderCategory(e, category, ORDER_DIRECTIONS.UP)
            })}
            {...(idx !== categories.length - 1 && {
              onOrderDown: e =>
                onOrderCategory(e, category, ORDER_DIRECTIONS.down)
            })}
          />
        </li>
      ))}
    </StyledCategoriesList>
  );
};

export default CategoriesList;
